import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "Not Found 404",
    perm: false,
    active: false,
    single: false,
    component: () => import("../views/../components/NotFound.vue"),
  },
  {
    path: "/",
    name: "login",
    perm: false,
    active: true,
    single: true,
    component: () => import("../views/auth"),
  },
  {
    path: "/forbiden",
    name: "Proibido",
    perm: false,
    active: false,
    single: false,
    component: () => import("../views/../components/Forbidden.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    perm: false,
    active: true,
    single: true,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/login",
    name: "Login",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/auth/"),
  },
  {
    path: "/conferences/master",
    name: "Distribuição",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/supplies/master/conferences/main.vue"),
  },
  {
    path: "/report/supplies",
    name: "Abastecimentos: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/abastecimento/main.vue"),
  },
  {
    path: "/report/supplies/:startDate/:endDate/:prefecture_id/:provider_id/:vehicle_id/:driver_id",
    name: "Abastecimentos: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/abastecimento/report.vue"),
  },
  {
    path: "/readjust/master",
    name: "Reajuste",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/supplies/master/readjust/main.vue"),
  },
  {
    path: "/retroactivity/master",
    name: "Retroatividade",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/supplies/master/retroactivity/main.vue"),
  },
  {
    path: "/blocked/master",
    name: "Bloqueados",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/supplies/master/blocked/main.vue"),
  },
  {
    path: "/report/master",
    name: "Gerador de relatório genérico",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/supplies/master/reports/main.vue"),
  },
  {
    path: "/report/master/generic/:startDate/:endDate/:prefecture_id/:vehicle_id",
    name: "Relatório Genérico",
    perm: false,
    active: true,
    props: true,
    single: false,
    component: () =>
      import("../views/supplies/master/reports/genericReport.vue"),
  },
  {
    path: "/report/master/blocked/:startDate/:endDate/:prefecture_id/:provider_id",
    name: "Relatório de Bloqueados",
    perm: false,
    active: true,
    props: true,
    single: false,
    component: () =>
      import("../views/supplies/master/reports/blockedReport.vue"),
  },
  {
    path: "/report/tce",
    name: "Gerador de relatório TCE",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/supplies/master/tce/main.vue"),
  },
  {
    path: "/report/tce/:prefecture_id/:startMonth/:endMonth/:year",
    name: "Relatório TCE",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/supplies/master/tce/report.vue"),
  },
  {
    path: "/report/tce/proprietario-frota",
    name: "Relatório TCE: Proprietário Frota: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/tce/proprietarioFrota.vue"),
  },
  {
    path: "/report/tce/proprietario-frota/:month/:year/:prefecture_id/:cod",
    name: "Relatório TCE: Proprietário Frota: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/tce/proprietarioFrotaReport.vue"),
  },
  {
    path: "/report/tce/locador-prestador",
    name: "Relatório TCE: Locador Prestador: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/tce/locadorPrestador.vue"),
  },
  {
    path: "/report/tce/locador-prestador/:month/:year/:prefecture_id/:cod",
    name: "Relatório TCE: Locador Prestador: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/tce/locadorPrestadorReport.vue"),
  },
  {
    path: "/report/tce/veiculos",
    name: "Relatório TCE: Veículos: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/tce/veiculos.vue"),
  },
  {
    path: "/report/tce/veiculos/:month/:year/:prefecture_id/:cod",
    name: "Relatório TCE: Veículos: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/tce/veiculosReport.vue"),
  },
  {
    path: "/report/tce/maquinas",
    name: "Relatório TCE: Máquinas: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/tce/maquinas.vue"),
  },
  {
    path: "/report/tce/maquinas/:month/:year/:prefecture_id/:cod",
    name: "Relatório TCE: Máquinas: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/tce/maquinasReport.vue"),
  },
  {
    path: "/report/tce/situacao-frota",
    name: "Relatório TCE: Situação Frota: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/tce/situacaoFrota.vue"),
  },
  {
    path: "/report/tce/situacao-frota/:month/:year/:prefecture_id/:cod",
    name: "Relatório TCE: Situação Frota: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/tce/situacaoFrotaReport.vue"),
  },
  {
    path: "/report/tce/abastecimento",
    name: "Relatório TCE: Abastecimento: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/tce/abastecimento.vue"),
  },
  {
    path: "/report/tce/abastecimento/:month/:year/:prefecture_id/:cod/:data_inicial?/:data_final?",
    name: "Relatório TCE: Abastecimento: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/tce/abastecimentoReport.vue"),
  },
  {
    path: "/report/veiculos",
    name: "Relatório: Veículos: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/report/veiculos.vue"),
  },
  {
    path: "/report/veiculos/:prefecture_id",
    name: "Relatório: Veículos: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/report/veiculosReport.vue"),
  },
  {
    path: "/report/motoristas",
    name: "Relatório: Motoristas: Filtro",
    perm: false,
    active: true,
    single: false,
    component: () => import("../views/report/motoristas.vue"),
  },
  {
    path: "/report/motoristas/:prefecture_id",
    name: "Relatório: Motoristas: Relatório",
    perm: false,
    active: true,
    single: false,
    props: true,
    component: () => import("../views/report/motoristasReport.vue"),
  },
  {
    path: "/supplies-manager/master",
    name: "Gestão de Abastecimentos: Master",
    perm: false,
    active: true,
    single: true,
    component: () => import("../views/supplies/master/"),
    children: [
      {
        path: "/supplies-manager/master",
        name: "Abastecimentos pelo administrador",
        component: () => import("../views/supplies/master/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/supplies-manager/master/create",
        name: "Novo Abastecimento pelo administrador",
        component: () => import("../views/supplies/master/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/supplies-manager/master/edit/:id",
        name: "Editar Abastecimento pelo administrador",
        props: true,
        component: () => import("../views/supplies/master/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/supplies-manager",
    name: "Gestão de Abastecimentos: Prefeitura",
    perm: false,
    active: true,
    single: true,
    component: () => import("../views/supplies/prefectures/"),
    children: [
      {
        path: "/supplies-manager",
        name: "Abastecimentos",
        component: () => import("../views/supplies/prefectures/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/supplies-manager/create",
        name: "Novo Abastecimento",
        component: () => import("../views/supplies/prefectures/new.vue"),
        active: true,
        single: false,
      },
      {
        path: "/supplies-manager/edit/:id",
        name: "Editar Abastecimento",
        props: true,
        component: () => import("../views/supplies/prefectures/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/supplies-manager/providers",
    name: "Gestão de Abastecimentos: Fornecedor",
    perm: false,
    active: true,
    single: true,
    component: () => import("../views/supplies/providers/"),
    children: [
      {
        path: "/supplies-manager/providers",
        name: "Conferência",
        component: () => import("../views/supplies/providers/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/supplies-manager/attendants",
    name: "Gestão de Abastecimentos: Frentista",
    perm: false,
    active: true,
    single: true,
    component: () => import("../views/supplies/attendants/"),
    children: [
      {
        path: "/supplies-manager/attendants",
        name: "Abastecer",
        component: () => import("../views/supplies/attendants/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/attendance-types",
    component: () => import("../views/settings/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/attendance-types",
        name: "Tipos de Atendimento",
        component: () => import("../views/settings/attendance_types.vue"),
        active: true,
        single: false,
      },
      {
        path: "/fuels-types",
        name: "Tipos de Combustível",
        props: true,
        component: () => import("../views/settings/fuels.vue"),
        active: true,
        single: false,
      },
      {
        path: "/consumption-types",
        name: "Tipos de Consumo",
        props: true,
        component: () => import("../views/settings/consumption.vue"),
        active: true,
        single: false,
      },
      {
        path: "/bonds-types",
        name: "Tipos de Vínculo",
        props: true,
        component: () => import("../views/settings/bonds.vue"),
        active: true,
        single: false,
      },
      {
        path: "/settings/logs",
        name: "Logs do Sistema",
        component: () => import("../views/settings/logs.vue"),
        active: true,
        single: false,
      },
      {
        path: "/settings/black-cards/clients",
        name: "Clientes Cartão Black",
        component: () => import("../views/settings/black-cards/clients.vue"),
        active: true,
        single: false,
      },
      {
        path: "/settings/black-cards/clients/create",
        name: "Cadastrar Cliente Cartão Black",
        component: () => import("../views/settings/black-cards/clients-create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/settings/black-cards/clients/edit/:id",
        name: "Editar Cliente Cartão Black",
        props: true,
        component: () => import("../views/settings/black-cards/clients-create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/settings/black-cards",
        name: "Gestão de Cartão Black",
        component: () => import("../views/settings/black-cards/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/settings/email",
        name: "Configuração de E-mail",
        component: () => import("../views/settings/email.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/drivers-manager",
    component: () => import("../views/drivers/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/drivers-manager",
        name: "Motoristas",
        component: () => import("../views/drivers/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/drivers-manager/create",
        name: "Cadastrar Motoristas",
        component: () => import("../views/drivers/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/drivers-manager/edit/:id",
        name: "Editar Motoristas",
        props: true,
        component: () => import("../views/drivers/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/providers-manager",
    component: () => import("../views/providers/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/providers-manager",
        name: "Fornecedores",
        component: () => import("../views/providers/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/providers-manager/create",
        name: "Cadastrar Fornecedor",
        component: () => import("../views/providers/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/providers-manager/edit/:id",
        name: "Editar Fornecedor",
        props: true,
        component: () => import("../views/providers/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/proprietario",
    component: () => import("../views/proprietario/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/proprietario",
        name: "Proprietario",
        component: () => import("../views/proprietario/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/proprietario/create",
        name: "Cadastrar Proprietario",
        component: () => import("../views/proprietario/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/proprietario/edit/:id",
        name: "Editar Proprietario",
        props: true,
        component: () => import("../views/proprietario/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/locador",
    component: () => import("../views/locador/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/locador",
        name: "Locador",
        component: () => import("../views/locador/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/locador/create",
        name: "Cadastrar Locador",
        component: () => import("../views/locador/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/locador/edit/:id",
        name: "Editar Locador",
        props: true,
        component: () => import("../views/locador/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/attendants-manager",
    component: () => import("../views/providers/attendants/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/attendants-manager",
        name: "Frentistas",
        component: () => import("../views/providers/attendants/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/attendants-manager/create",
        name: "Cadastrar Frentista",
        component: () => import("../views/providers/attendants/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/attendants-manager/edit/:id",
        name: "Editar Frentista",
        props: true,
        component: () => import("../views/providers/attendants/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/users-manager",
    component: () => import("../views/users/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/users-manager",
        name: "Usuários",
        component: () => import("../views/users/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/users-manager/create",
        name: "Cadastrar Usuário",
        component: () => import("../views/users/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/users-manager/edit/:id",
        name: "Editar Usuário",
        props: true,
        component: () => import("../views/users/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/prefectures-manager",
    component: () => import("../views/prefectures/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/prefectures-manager",
        name: "Prefeituras",
        component: () => import("../views/prefectures/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/prefectures-manager/create",
        name: "Cadastrar Prefeituras",
        component: () => import("../views/prefectures/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/prefectures-manager/edit/:id",
        name: "Editar Prefeituras",
        props: true,
        component: () => import("../views/prefectures/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/prefectures-manager/secretariats/:id",
        name: "Secretarias",
        props: true,
        component: () => import("../views/prefectures/secretariats.vue"),
        active: true,
        single: false,
      },
      {
        path: "/prefectures-manager/secretariats/subsectors/:id",
        name: "Sub-Setores",
        props: true,
        component: () => import("../views/prefectures/subsector.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/vehicles-manager",
    component: () => import("../views/vehicles/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/vehicles-manager/create",
        name: "Cadastrar Veículos",
        component: () => import("../views/vehicles/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/models",
        name: "Modelos de Veículos",
        props: true,
        component: () => import("../views/vehicles/models.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/colors",
        name: "Cores de Veículos",
        props: true,
        component: () => import("../views/vehicles/colors.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/brands",
        name: "Marcas de Veículos",
        props: true,
        component: () => import("../views/vehicles/brands.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/situacao/create",
        name: "Cadastrar Situação da Frota",
        props: true,
        component: () => import("../views/vehicles/situacao/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/situacao",
        name: "Situação da Frota: Listagem",
        props: true,
        component: () => import("../views/vehicles/situacao/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/edit/:id",
        name: "Editar Veículos",
        props: true,
        component: () => import("../views/vehicles/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/vehicles-manager/:id?",
        name: "Veículos",
        props: true,
        component: () => import("../views/vehicles/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/machines-manager",
    component: () => import("../views/vehicles/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/machines-manager/create",
        name: "Cadastrar Máquinas",
        component: () => import("../views/vehicles/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/machines-manager/edit/:id",
        name: "Editar Máquinas",
        props: true,
        component: () => import("../views/vehicles/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/machines-manager/:id?",
        name: "Máquinas",
        props: true,
        component: () => import("../views/vehicles/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/access-groups",
    component: () => import("../views/users/permissions/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/access-groups",
        name: "Grupos e Permissōes",
        component: () => import("../views/users/permissions/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/access-groups/create",
        name: "Cadastrar Grupos e Permissōes",
        component: () => import("../views/users/permissions/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/access-groups/edit/:id",
        name: "Editar Grupos e Permissōes",
        props: true,
        component: () => import("../views/users/permissions/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/nfe",
    name: "Notas Fiscais",
    component: () => import("../views/billings/nfe/main.vue"),
    active: true,
    single: false,
  },
  {
    path: "/nfe/create",
    name: "Cadastrar Nota Fiscal",
    component: () => import("../views/billings/nfe/create.vue"),
    active: true,
    single: false,
  },
  {
    path: "/nfe/edit/:id",
    name: "Editar Nota Fiscal",
    props: true,
    component: () => import("../views/billings/nfe/create.vue"),
    active: true,
    single: false,
  },
  {
    path: "/nfe/:startDate/:endDate/:prefecture_id/:provider_id",
    name: "Relatório de notafiscal",
    props: true,
    component: () => import("../views/billings/nfe/report/reportMain.vue"),
    active: true,
    single: false,
  },
  {
    path: "/billings",
    component: () => import("../views/billings/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/billings",
        name: "Faturamento",
        component: () => import("../views/billings/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/create",
        name: "Cadastrar Faturamento",
        component: () => import("../views/billings/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/edit/:id",
        name: "Editar Faturamento",
        props: true,
        component: () => import("../views/billings/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/provider/edit/:id",
        name: "Editar Faturamento Fornecedor",
        props: true,
        component: () => import("../views/billings/createforprovider.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/report/all/:startDate/:endDate/:prefecture_id/:provider_id/:vehicle_id",
        name: "Relatorio Geral",
        props: true,
        component: () => import("../views/billings/reports/reportAll.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/report/conferences/:startDate/:endDate/:prefecture_id/:provider_id/:vehicle_id",
        name: "Conferencia Geral",
        props: true,
        component: () => import("../views/billings/reports/conferenceAll.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/report/single/:startDate/:endDate/:prefecture_id/:provider_id/:vehicle_id",
        name: "Conferência Individual",
        props: true,
        component: () => import("../views/billings/reports/billingSingle.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/report/single/:startDate/:endDate/:prefecture_id/:provider_id/:vehicle_id/:sec_id",
        name: "Conferência Por Secretaria",
        props: true,
        component: () => import("../views/billings/reports/billingSecs.vue"),
        active: true,
        single: false,
      },
      {
        path: "/billings/report/nfe/:startDate/:endDate/:prefecture_id/:provider_id",
        name: "Conferência NFE",
        props: true,
        component: () => import("../views/billings/reports/reportNFE.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/bidding-manager",
    component: () => import("../views/biddings/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/biddings-manager",
        name: "Gerenciar Licitaçōes",
        component: () => import("../views/biddings/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-manager/create",
        name: "Cadastrar Gerenciar Licitaçōes",
        component: () => import("../views/biddings/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-manager/edit/:id",
        name: "Editar Licitaçōes",
        props: true,
        component: () => import("../views/biddings/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-types",
        name: "Tipos de Licitação",
        props: true,
        component: () => import("../views/biddings/types.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-modalities",
        name: "Modalidades de Licitação",
        props: true,
        component: () => import("../views/biddings/modalities.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-donnations/create/:b_id/:p_id",
        name: "Adicionar",
        component: () => import("../views/biddings/donnations/create.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-donnations/edit/:id/:p_id",
        name: "Editar ",
        props: true,
        component: () => import("../views/biddings/donnations/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-items/create/:b_id",
        name: "Adicionar Item",
        component: () => import("../views/biddings/items/create.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-items/edit/:id/:b_id",
        name: "Editar Item",
        props: true,
        component: () => import("../views/biddings/items/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/biddings-items/types",
        name: "Tipos de Itens",
        component: () => import("../views/biddings/items/types.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-items/descriptions",
        name: "Descrição dos Itens",
        component: () => import("../views/biddings/items/descriptions.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-items/brands",
        name: "Marcas dos Itens",
        component: () => import("../views/biddings/items/brands.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-items/stock-types",
        name: "Tipos de Estoque",
        component: () => import("../views/biddings/items/stocktypes.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-contracts/create/:b_id",
        name: "Adicionar Contrato",
        component: () => import("../views/biddings/contracts/create.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/biddings-contracts/edit/:id/:b_id",
        name: "Editar Contrato",
        props: true,
        component: () => import("../views/biddings/contracts/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/parts-and-services/biddings-manager",
    component: () => import("../views/partsAndServices/biddings/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/biddings-manager",
        name: "Gerenciar Licitaçōes | Peças e Serviços",
        component: () => import("../views/partsAndServices/biddings/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-manager/create",
        name: "Cadastrar Licitaçōes | Peças e Serviços",
        component: () =>
          import("../views/partsAndServices/biddings/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-manager/edit/:id",
        name: "Editar Licitaçōes | Peças e Serviços",
        props: true,
        component: () =>
          import("../views/partsAndServices/biddings/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-donnations/create/:b_id/:p_id",
        name: "Adicionar | Peças e Serviços",
        component: () =>
          import("../views/partsAndServices/biddings/donnations/create.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-donnations/edit/:id/:p_id/:b_id",
        name: "Editar | Peças e Serviços",
        props: true,
        component: () =>
          import("../views/partsAndServices/biddings/donnations/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-items/create/:b_id",
        name: "Adicionar Item | Peças e Serviços",
        component: () =>
          import("../views/partsAndServices/biddings/items/create.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-items/edit/:id/:b_id",
        name: "Editar Item | Peças e Serviços",
        props: true,
        component: () =>
          import("../views/partsAndServices/biddings/items/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-contracts/create/:b_id",
        name: "Adicionar Contrato | Peças e Serviços",
        component: () =>
          import("../views/partsAndServices/biddings/contracts/create.vue"),
        active: true,
        props: true,
        single: false,
      },
      {
        path: "/parts-and-services/biddings-contracts/edit/:id/:b_id",
        name: "Editar Contrato | Peças e Serviços",
        props: true,
        component: () =>
          import("../views/partsAndServices/biddings/contracts/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/parts-and-services/nf",
    component: () => import("../views/partsAndServices/nf/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/nf",
        name: "Nota Fiscal | Peças e Serviços",
        component: () => import("../views/partsAndServices/nf/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/nf/create",
        name: "Gerar Nota Fiscal | Peças e Serviços",
        component: () => import("../views/partsAndServices/nf/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/nf/edit/:id",
        name: "Editar Nota Fiscal | Peças e Serviços",
        props: true,
        component: () => import("../views/partsAndServices/nf/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/parts-and-services/os",
    component: () => import("../views/partsAndServices/os/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/os",
        name: "Ordem de Serviço | Peças e Serviços",
        component: () => import("../views/partsAndServices/os/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/os/create",
        name: "Gerar Ordem de Serviço | Peças e Serviços",
        component: () => import("../views/partsAndServices/os/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/os/edit/:id",
        name: "Editar Ordem de Serviço | Peças e Serviços",
        props: true,
        component: () => import("../views/partsAndServices/os/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/parts-and-services/os-release",
    component: () => import("../views/partsAndServices/osRelease/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/os-release",
        name: "Liberação de OS | Peças e Serviços",
        component: () => import("../views/partsAndServices/osRelease/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/parts-and-services/providers-manager",
    component: () => import("../views/partsAndServices/providers/"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/providers-manager",
        name: "Fornecedores | Peças e Serviços",
        component: () => import("../views/partsAndServices/providers/main.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/providers-manager/create",
        name: "Cadastrar Fornecedor | Peças e Serviços",
        component: () =>
          import("../views/partsAndServices/providers/create.vue"),
        active: true,
        single: false,
      },
      {
        path: "/parts-and-services/providers-manager/edit/:id",
        name: "Editar Fornecedor | Peças e Serviços",
        props: true,
        component: () =>
          import("../views/partsAndServices/providers/create.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/parts-and-services/report/synthetic",
    component: () => import("../views/partsAndServices/report/synthetic"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/report/synthetic",
        name: "Relatório Sintético: Filtro",
        active: true,
        single: false,
        component: () =>
          import("../views/partsAndServices/report/synthetic/main.vue"),
      },
      {
        path: "/parts-and-services/report/synthetic/:prefecture_id/:startDate/:endDate",
        name: "Relatório Sintético: Relatório",
        active: true,
        single: false,
        props: true,
        component: () =>
          import("../views/partsAndServices/report/synthetic/report.vue"),
      },
    ],
  },
  {
    path: "/parts-and-services/report/analytical",
    component: () => import("../views/partsAndServices/report/analytical"),
    perm: true,
    active: true,
    single: false,
    children: [
      {
        path: "/parts-and-services/report/analytical",
        name: "Relatório Analítico: Filtro",
        active: true,
        single: false,
        component: () =>
          import("../views/partsAndServices/report/analytical/main.vue"),
      },
      {
        path: "/parts-and-services/report/analytical/:prefecture_id/:startDate/:endDate",
        name: "Relatório Analítico: Relatório",
        active: true,
        single: false,
        props: true,
        component: () =>
          import("../views/partsAndServices/report/analytical/report.vue"),
      },
    ],
  },
  {
    path: "/authorizations",
    name: "Gestão de Autorizações",
    perm: true,
    active: true,
    single: false,
    component: () => import("../views/authorizations/"),
    children: [
      {
        path: "/authorizations",
        name: "Abastecimentos Autorizados",
        component: () => import("../views/authorizations/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
  {
    path: "/extra",
    name: "Gestão de Extras",
    perm: true,
    active: true,
    single: false,
    component: () => import("../views/extra/"),
    children: [
      {
        path: "/extra",
        name: "Abastecimentos Extras",
        component: () => import("../views/extra/main.vue"),
        active: true,
        single: false,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
